export default "__VITE_ASSET__etxaCc2x__"